import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useSessionStore } from "../store/useSessionStore";
import { AdminAuthService } from "@/service/api";
import { ROUTES } from "@/routes/constants/routes";

const useAdminSignIn = () => {
  const setSession = useSessionStore.getState().setSession;
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: AdminAuthService.signIn,
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response?.status === 401) {
          toast.error("E-mail ou senha inválidos", { toastId: "admin_signin_error" });
        } else {
          toast.error("Erro ao tentar fazer login. Tente novamente mais tarde.", {
            toastId: "admin_signin_error",
          });
        }
      }
    },
    onSuccess: (data) => {
      setSession(data);
      navigate(ROUTES.DASHBOARD.HOME);
    },
  });

  return mutation;
};

export default useAdminSignIn;
